import { OfferNotificationTemplateChannel as Ch, type NotificationTemplateDTO } from '@today/types'
import { languageOf } from './picker-options'

/** The channel order preselection tries (REQ-107). */
const PRESELECT_ORDER = [Ch.ALL, Ch.EMAIL, Ch.SMS, Ch.WHATSAPP] as const

/** What preselection reads from the offer. */
export interface OfferMessageState {
	locale: string
	notificationTemplateId: string | null
	notificationBody: string | null
}

/**
 * Step 3's preselection (TO-140 offer-notification-message REQ-107): for an offer
 * with no link and no body, the active default template of its language by channel
 * order ALL, EMAIL, SMS, WHATSAPP; otherwise (or with no default) null.
 */
export function preselectTemplate(
	templates: readonly NotificationTemplateDTO[],
	offer: OfferMessageState,
): NotificationTemplateDTO | null {
	if (offer.notificationTemplateId !== null || offer.notificationBody !== null) return null
	const language = languageOf(offer.locale)
	const defaults = templates.filter((t) => t.isActive && t.isDefaultForChannel && t.locale === language)
	for (const channel of PRESELECT_ORDER) {
		const found = defaults.find((t) => t.channelType === channel)
		if (found) return found
	}
	return null
}
